import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { monthGrid, sameDay, ymd, monthName, weekdayName } from './calendarMath';

// The small month in the sidebar: jump to any day. It follows the main view's date, and its
// own arrows browse without moving the main view until a day is picked.
export default function MiniMonth({ anchor, range, onPick, busyDays }) {
  const [shown, setShown] = useState(() => new Date(anchor.getFullYear(), anchor.getMonth(), 1));
  const ay = anchor.getFullYear(); const am = anchor.getMonth();
  useEffect(() => { setShown(new Date(ay, am, 1)); }, [ay, am]);
  const grid = monthGrid(shown);
  const today = new Date();
  const [r0, r1] = range || [];
  return (
    <div className="select-none">
      <div className="flex items-center justify-between pl-1.5 mb-1">
        <span className="text-[13px] font-semibold text-slate-800">{monthName(shown.getMonth())} {shown.getFullYear()}</span>
        <div className="flex">
          <button type="button" aria-label="Previous month" onClick={() => setShown(new Date(shown.getFullYear(), shown.getMonth() - 1, 1))}
            className="w-7 h-7 rounded-full flex items-center justify-center text-slate-500 hover:bg-slate-100"><ChevronLeft size={15} aria-hidden /></button>
          <button type="button" aria-label="Next month" onClick={() => setShown(new Date(shown.getFullYear(), shown.getMonth() + 1, 1))}
            className="w-7 h-7 rounded-full flex items-center justify-center text-slate-500 hover:bg-slate-100"><ChevronRight size={15} aria-hidden /></button>
        </div>
      </div>
      <div className="grid grid-cols-7 text-center" role="grid" aria-label={`${monthName(shown.getMonth())} ${shown.getFullYear()}`}>
        {[1, 2, 3, 4, 5, 6, 0].map((d) => <span key={d} className="text-[10.5px] font-semibold text-slate-400 h-6 leading-6" aria-hidden>{weekdayName(d).slice(0, 1)}</span>)}
        {grid.map((d) => {
          const out = d.getMonth() !== shown.getMonth();
          const isToday = sameDay(d, today);
          const inRange = r0 && r1 && d >= r0 && d <= r1;
          const busy = busyDays && busyDays.has(ymd(d));
          return (
            <button key={ymd(d)} type="button" onClick={() => onPick(d)}
              aria-label={`${weekdayName(d.getDay())} ${d.getDate()} ${monthName(d.getMonth())}`} aria-current={isToday ? 'date' : undefined}
              className={clsx('relative mx-auto w-7 h-7 rounded-full text-[11.5px] tabular-nums transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500',
                isToday ? 'bg-indigo-600 text-white font-semibold' : inRange ? 'bg-indigo-100 text-indigo-800 font-semibold' : out ? 'text-slate-400 hover:bg-slate-100' : 'text-slate-700 hover:bg-slate-100')}>
              {d.getDate()}
              {busy && !isToday && <span className="absolute bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-indigo-400" aria-hidden />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
